import { baseActions } from 'store/modules/Base/actions';
import { metaActions } from 'store/modules/Meta/actions';
import { caseActions } from 'store/modules/Case/actions';
import { authActions } from 'store/modules/Auth/actions';
import { portfolioBuilderActions } from 'store/modules/PorfolioBuilder/actions';
import { ipsActions } from 'store/modules/IPS/actions';
import { recommendationActions } from 'store/modules/Recommendations/actions';
import { existingPolicyAnalysisActions } from 'store/modules/ExistingPolicyAnalysis/actions';
import { questionnareActions } from 'store/modules/Quesionnare/actions';
import { webSocketActions } from './modules/WebSocket/actions';
import { AdvisorActions } from './modules/Advisor/actions';
import { PolicyImportActions } from './modules/PolicyImport/actions';
import { firmActions } from './modules/Firm/actions';
import { dragAndDropActions } from './modules/DragAndDrop/actions';
import { fundsAndMpsRefActions } from './modules/FundsAndMpsCipRef/actions';
import { riskMappingActions } from './modules/RiskMapping/actions';
import { capacityForLossActions } from './modules/CapacityForLoss/actions';
import { reportActions } from './modules/Report/actions';
import { cipActions } from './modules/CIP/actions';
import { investmentAnalyserActions } from './modules/InvestmentAnalyser/actions';
import { experienceActions } from './modules/Experience/actions';

export default {
  baseActions,
  metaActions,
  caseActions,
  authActions,
  portfolioBuilderActions,
  ipsActions,
  recommendationActions,
  existingPolicyAnalysisActions,
  questionnareActions,
  webSocketActions,
  AdvisorActions,
  PolicyImportActions,
  firmActions,
  dragAndDropActions,
  fundsAndMpsRefActions,
  riskMappingActions,
  capacityForLossActions,
  reportActions,
  cipActions,
  investmentAnalyserActions,
  experienceActions
};
